import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=1f92fe07&scoped=true&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/AccordionView/AccordionItem.less?vue&type=style&index=0&id=1f92fe07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f92fe07",
  null
  
)

export default component.exports